import { cx } from '@/lib/cx';

/**
 * The only loading indicator in the app. A 3/4 arc rotating at 700ms — fast
 * enough to read as "working", slow enough not to buzz on a screen that may
 * show several at once.
 *
 * Prefer <Skeleton> for content that has a known shape (table rows, cards);
 * a spinner tells the user nothing about what is arriving. Where a whole
 * surface is waiting and its shape is not known — a drawer holding a record —
 * use <LoadingState>, which is this with a caption and the centring.
 */
export function Spinner({ size = 14, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={cx('animate-spin', className)}
      aria-hidden
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="47 63"
        opacity="0.9"
      />
    </svg>
  );
}

/** Placeholder bar matching the shape of the content it stands in for. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cx('animate-pulse rounded-sm bg-subtle', className)} aria-hidden />;
}
